<script lang="ts">
  import { onMount } from 'svelte';
  import { loginModel } from '../login/loginModel';
  import { i18n } from '../util/i18n/i18n';
  import { trackEvent } from '../util/snowplow';

  onMount(() => {
    trackEvent({ action: 'state:login' });
  });

  const onClick = () => {
    loginModel.login();
  };
</script>

<p>
  {i18n('login.login-info')}
</p>

<button
  on:click={onClick}
  class="primary login-button"
  data-test-id="login-button"
>
  {i18n('login.login')}</button
>

<style>
  .login-button {
    box-shadow: 0 0 0 0 var(--color-button-primary-bg);
    transform: scale(0.95);
    animation: pulse 1.5s infinite;
  }
  @keyframes pulse {
    0% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 var(--color-button-primary-bg);
    }

    70% {
      transform: scale(1);
    }

    100% {
      transform: scale(0.95);
      box-shadow: 0 0 10px 20px rgba(0, 0, 0, 0);
    }
  }
  p {
    margin-bottom: var(--spacing-16);
    text-align: center;
    max-width: 25rem;
    font-size: 0.875rem;
    line-height: normal;
    text-transform: uppercase;
    letter-spacing: 0.05rem;
  }
</style>
